import Joi from '@hapi/joi'

export const routeDeductionDetailsReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Please select valid Group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Company").messages({
        "any.invalid": `Please select valid Company`,
        "any.required": `Company required`
    }),
    collectionPointID: Joi.number().label("Collectionpoint").messages({
        "any.invalid": `Please select valid Collectionpoint`,
        "any.required": `Collectionpoint required`
    }),
    toDate: Joi.string().invalid("").label("toDate").required().messages({
        "any.invalid": `Please select toDate`,
        "any.required": `toDate required`
    }),
    fromDate: Joi.string().invalid("").label("fromDate").required().messages({
        "any.invalid": `Please select fromDate`,
        "any.required": `fromDate required`
    }),
}